/**
 * Layout de Emails (Snov): la fila de contexto (la sección, como en WhatsApp; la marca se elige en el menú), la línea de
 * la conexión con Snov y la página. Las secciones están en el menú lateral, debajo de «Emails» (`SeccionesEmails.ts`).
 *
 * Todo va adentro de `EstadoEmailsProvider`: las páginas leen de ahí si se está actualizando y se vuelven a pedir
 * solas cuando termina una actualización.
 */

import { Outlet } from "react-router-dom";
import { EstadoEmailsProvider } from "../contexto";
import { EstadoSnov } from "../components/EstadoSnov";

export default function EmailsLayout() {
  return (
    <EstadoEmailsProvider>
      <div className="min-h-screen p-6 md:p-8 animate-fade-in">
        <div className="mx-auto max-w-6xl space-y-5">
          <div className="flex items-center gap-2 flex-wrap">
            <h1 className="text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full bg-sky-50 text-sky-700">Emails</h1>
          </div>
          <EstadoSnov />
          <Outlet />
        </div>
      </div>
    </EstadoEmailsProvider>
  );
}
